// libs
import { styled } from '@nykaa/ui-components';

// constants
import { CLASSNAMES } from 'shared/layouts/Listing/constants';
import {
  BREAKPOINTS,
  DWEB_MAX_WIDTH,
  MWEB_COLLAPSIBLE_FOOTER_HEIGHT,
  MWEB_HEADER_HEIGHT,
  MWEB_WISHLIST_HEADER_HEIGHT,
} from 'shared/styles/base';
import { DESKTOP_PRODUCT_WIDTH, NUMBER_OF_PRODUCTS_DESKTOP } from './constant';

// to make footer stay at bottom
export const Container = styled.div`
  width: 100%;
  // header + wishlist header + collapsible footer with top margin (50 + 48 + 64)
  min-height: calc(
    100vh - ${MWEB_HEADER_HEIGHT + MWEB_WISHLIST_HEADER_HEIGHT + MWEB_COLLAPSIBLE_FOOTER_HEIGHT}px
  );
  padding: ${({ theme }) =>
    `${theme.spacing.spacing0} ${theme.spacing.spacing20} ${theme.spacing.spacing100} ${theme.spacing.spacing20}`};
`;

export const ProductsContainer = styled.div<{ productWidth: number }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: ${DWEB_MAX_WIDTH}px;

  // dweb support
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-width: ${BREAKPOINTS.DESKTOP}px;
    position: relative;
    margin: auto;
  }

  & .${CLASSNAMES.PRODUCT} {
    width: calc(50% - 1px);
    display: inline-block;

    // dweb support
    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      width: ${({ productWidth }) => `${productWidth}px`};

      margin-right: calc(
        (100% - ${NUMBER_OF_PRODUCTS_DESKTOP * DESKTOP_PRODUCT_WIDTH}px) /
          ${NUMBER_OF_PRODUCTS_DESKTOP - 1}
      );

      :nth-of-type(${NUMBER_OF_PRODUCTS_DESKTOP}n) {
        margin-right: 0;
      }
    }
  }
`;

export const PageIO = styled.div`
  height: 1px;
`;
